module.exports = __webpack_public_path__ + "img/partners12.a681291c.jpg";